/* =========================================================================
   BUMPY VICE — filtres et tri de collection
   Les filtres se rechargent sans recharger la page (Section Rendering API),
   avec mise a jour de l'URL pour garder des liens partageables.
   Sans JavaScript, les formulaires fonctionnent normalement.

   Correctif v4.0 : le <select> de tri est relie au formulaire de filtres par
   l'attribut `form=`, mais il n'en est pas un descendant dans le DOM.
   `e.target.closest('[data-facets-form]')` renvoyait donc toujours null et
   aucun tri ne se declenchait. On l'intercepte desormais explicitement, avec
   un repli par navigation classique quand la collection n'a pas de filtres.
   ========================================================================= */
(function () {
  'use strict';

  var GRID = '[data-product-grid]';
  var FACETS = '[data-facets-inner]';
  var TOOLBAR = '[data-toolbar]';
  var ACTIVE = '[data-active-facets]';
  var SORT = '#sort-by, [data-sort-select]';

  var sectionId = null;
  var pending = null;

  function serialize(form) {
    var params = new URLSearchParams(new FormData(form));
    // Les champs vides encombrent l'URL sans rien filtrer.
    Array.prototype.slice.call(params.keys()).forEach(function (k) {
      if (params.getAll(k).every(function (v) { return v === ''; })) params.delete(k);
    });
    params.delete('page');
    return params;
  }

  function setBusy(busy) {
    var grid = document.querySelector(GRID);
    if (grid) grid.classList.toggle('facets-loading', busy);
  }

  function swap(selector, doc) {
    var current = document.querySelector(selector);
    var fresh = doc.querySelector(selector);
    if (current && fresh) current.innerHTML = fresh.innerHTML;
  }

  function render(url, push) {
    setBusy(true);
    if (pending) pending.abort();
    pending = new AbortController();

    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;

    return fetch(fetchUrl, { signal: pending.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        swap(GRID, doc);
        swap(FACETS, doc);
        swap(TOOLBAR, doc);
        swap(ACTIVE, doc);

        if (push !== false) history.pushState({ facets: url }, '', url);
        setBusy(false);

        var grid = document.querySelector(GRID);
        if (grid) {
          var top = grid.getBoundingClientRect().top + window.scrollY - 120;
          if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
        }

        document.dispatchEvent(new CustomEvent('bumpy:facets:updated', { bubbles: true }));
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        setBusy(false);
        window.location.href = url; // repli : navigation classique
      });
  }

  /* Construit l'URL a partir du formulaire de filtres (qui inclut deja le
     select de tri grace a l'attribut form=) ou, a defaut, de l'URL courante. */
  function urlFromState(form, sortValue) {
    var params;

    if (form) {
      params = serialize(form);
    } else {
      params = new URLSearchParams(window.location.search);
      params.delete('page');
    }

    if (sortValue) params.set('sort_by', sortValue);

    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function onFormChange(e) {
    var form = e.target.closest('[data-facets-form]');
    if (!form) return;
    e.preventDefault();
    render(urlFromState(form, null));
  }

  function onSortChange(sel) {
    var form = document.querySelector('[data-facets-form]');
    var url = urlFromState(form, sel.value);

    // Pas de section a rafraichir (page de recherche sans filtres, etc.) :
    // on recharge normalement plutot que de ne rien faire.
    if (!sectionId) { window.location.assign(url); return; }
    render(url);
  }

  function boot() {
    var container = document.querySelector('[data-facets-section]');
    if (container) sectionId = container.dataset.facetsSection;

    if (document.documentElement.dataset.facetsReady === 'true') return;
    document.documentElement.dataset.facetsReady = 'true';

    // Cases a cocher, champs de prix, et tri.
    document.addEventListener('change', function (e) {
      var node = e.target;
      if (!node || !node.closest) return;

      var sel = node.closest(SORT);
      if (sel && sel.tagName === 'SELECT') {
        e.preventDefault();
        e.stopPropagation();
        onSortChange(sel);
        return;
      }

      if (node.closest('[data-facets-form]')) onFormChange(e);
    });

    document.addEventListener('submit', function (e) {
      if (e.target.closest('[data-facets-form]')) onFormChange(e);
    });

    // Retrait d'un filtre actif + pagination.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-facet-remove], [data-facets-section] .pagination a');
      if (!link || !link.href) return;
      e.preventDefault();
      render(link.href);
    });

    // Champs de prix : on laisse le temps de taper.
    var priceTimer;
    document.addEventListener('input', function (e) {
      var input = e.target.closest('[data-facet-price]');
      if (!input) return;
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () {
        var form = input.closest('[data-facets-form]');
        if (form) form.dispatchEvent(new Event('change', { bubbles: true }));
      }, 700);
    });

    window.addEventListener('popstate', function () {
      render(window.location.href, false);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
